import React from "react";
import PropTypes from "prop-types";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import Location from "./Location";
import _ from "lodash";

const NonLocations = () => (
  <tr>
    <td colSpan={4} className="text-center">
      No any locations
    </td>
  </tr>
);

class Locations extends React.Component {
  state = {
    addedIds: this.props.data.map(l => l.locationId)
  }

  sortPriority = (a, b) => (a.priority - b.priority);

  handleChange = (locationIdToAdd, locationIdToRemove) => {
    const ids = this.state.addedIds;
    const index = ids.indexOf(locationIdToRemove);
    if(index !== -1)
      ids.splice(index, 1);

    if(locationIdToAdd)
      ids.push(locationIdToAdd)

    this.setState({ addedIds: ids })
  }

  allowDelete = (locations, location) => {
    if(location.active && _.filter(locations, l => l.active).length > 1)
      return true
    else if(!location.active && locations.length > 1)
      return true
    else
      return false
  }

  render() {
    const {
      data,
      allLocations,
      onDelete,
      onSave,
      onRemove,
      onDragEnd,
      futureShiftCountByLocation,
      futureShiftActionOptions,
    } = this.props;

    return (
      <DragDropContext onDragEnd={onDragEnd}>
        <table className="table table-clean table-white table-draggable">
          <thead>
            <tr>
              <th />
              <th>Name</th>
              <th>Primary</th>
              <th />
            </tr>
          </thead>
    
          <Droppable droppableId="table">
            {droppableProvided => (
              <tbody
                ref={ref => {
                  droppableProvided.innerRef(ref);
                }}
                {...droppableProvided.droppableProps}
              >
                {data.sort(this.sortPriority).map((item, index) => (
                  <Draggable
                    index={index}
                    draggableId={item.id || item._id}
                    key={item.id || item._id}
                  >
                    {(provided, snapshot) => (
                      <Location
                        provided={provided}
                        snapshot={snapshot}
                        data={item}
                        allLocations={allLocations}
                        addedIds={this.state.addedIds
                          .filter(id => id !== item.locationId)}
                        allowDelete={this.allowDelete(data, item)}
                        onDelete={onDelete}
                        onSave={onSave}
                        onRemove={onRemove}
                        onChange={this.handleChange}
                        futureShiftCountByLocation={futureShiftCountByLocation}
                        futureShiftActionOptions={futureShiftActionOptions}
                      />
                    )}
                  </Draggable>
                ))}
    
                {data.length === 0 ? <NonLocations /> : null}
              </tbody>
            )}
          </Droppable>
        </table>
      </DragDropContext>
    );
  }
}

Locations.defaultProps = {
  data: PropTypes.array.isRequired,
  allLocations: PropTypes.array,
  onDelete: PropTypes.func,
  onSave: PropTypes.func,
  onRemove: PropTypes.func,
  onDragEnd: PropTypes.func,
  futureShiftCountByLocation: PropTypes.object.isRequired,
  futureShiftActionOptions: PropTypes.array.isRequired,
};

export default Locations;
